import { render, staticRenderFns } from "./Department.vue?vue&type=template&id=a983fcfe"
import script from "./Department.vue?vue&type=script&lang=js"
export * from "./Department.vue?vue&type=script&lang=js"
import style0 from "./Department.vue?vue&type=style&index=0&id=a983fcfe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports